export default __webpack_public_path__ + "091b773e8f868475470ecef4b4fe0691.svg";